import { Component, inject, OnInit } from "@angular/core";
import { SettingsService } from "../../../../../../services/settings.service";
import { LayoutService } from "../../../../../../shared/components/app-layout/shared-layout/layout.service";
import { CardVariant } from "../../../../../../shared/components/dashboard/summary-cards-variant/summary-cards-variant.component";
import {
  faBell,
  faBuilding,
  faClock,
  faDroplet,
  faTemperature0,
  faTemperatureEmpty,
  faThermometer,
} from "@fortawesome/free-solid-svg-icons";
import { faTemperature4 } from "@fortawesome/free-solid-svg-icons/faTemperature4";
import { GET_WAREHOUSE_LATEST_READINGS } from "../../../../../../store/entities/shared/temp-humidity-graph/temp-humidity-graph.graphql";
import { GraphqlService } from "../../../../../../services/graphql.service";
import { ActivatedRoute } from "@angular/router";
import { StoreItemActions } from "../../../../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../../../../store/entities/store-item/store-item.model";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../../../store";
import {
  GET_WAREHOUSE_DASHBOARD_DATA,
  GET_WAREHOUSE_REALTIME_READINGS,
} from "../../../../../../store/entities/warehouse-management/item-dashboard/item-dashboard.graphql";
import { ItemDashboard } from "../../../../../../store/entities/warehouse-management/item-dashboard/item-dashboard.model";
import {
  selectFilterStoreItem,
  selectStoreItems,
} from "../../../../../../store/entities/store-item/store-item.selectors";
import _ from "lodash";
import { Device } from "../../../../../../store/entities/warehouse-management/device/device.model";
import { GET_ZONE_DATA } from "../../../../../../store/entities/warehouse-management/building-zone/building-zone.graphql";
import { WarehouseZone } from "../../../../../../store/entities/warehouse-management/building-zone/building-zone.model";
import { environment } from "../../../../../../../environments/environment";
import { gql } from "graphql-tag";
import { responseField } from "../../../../../../store/base.graphql";
import { BaseResponse } from "../../../../../../common/interfaces/global-interfaces";
import { NotificationService } from "../../../../../../services/notification.service";

interface HeatmapDashboard {
  sensor_id?: string;
  serial_number?: string;
  readings?: {
    temp?: number;
    hum?: number;
  };
  bins?: string[];
  tempOpacity?: string;
  humOpacity?: string;
}

export const GET_ZONE_HEATMAP_DATA = gql`
query GetZoneHeatmapData($filtering: ReportsFilteringInputObject) {
  getZoneHeatmapData(filtering: $filtering) {
    response {
      ${responseField}
    }
    data {
      dashboardData
    }
  }
}`;

@Component({
  selector: "app-warehouse-zone-view",
  templateUrl: "./warehouse-zone-view.component.html",
  styleUrl: "./warehouse-zone-view.component.scss",
})
export class WarehouseZoneViewComponent implements OnInit {
  private settingService: SettingsService = inject(SettingsService);
  private layoutService: LayoutService = inject(LayoutService);
  private apollo: GraphqlService = inject(GraphqlService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private store: Store<AppState> = inject(Store<AppState>);
  private notificationService: NotificationService =
    inject(NotificationService);
  private refreshInterval: any;

  public items: any[];
  public serviceUsage!: any[];
  public tempLineChartsData: any[];
  public humLineChartsData: any[];
  public xAxis = [];

  protected readonly faTemperature4 = faTemperature4;
  protected readonly faTemperature0 = faTemperature0;
  protected readonly faDroplet = faDroplet;
  protected readonly faBuilding = faBuilding;
  protected readonly faBell = faBell;
  protected readonly faThermometer = faThermometer;
  protected readonly length = length;

  zoneDashboardData: ItemDashboard;
  currentTime: string;
  sixHoursPast: string;
  title;
  dashboardData: any;
  dashboardRealtimeSummary: any;
  selectedTimeRange: string = "month";
  lineChartsTabs: { name: string; slug: "lineChartsTemp" | "lineChartsHum" }[] =
    [
      { name: "Temperature", slug: "lineChartsTemp" },
      { name: "Humidity", slug: "lineChartsHum" },
    ];
  activeSlugLineCharts: "lineChartsTemp" | "lineChartsHum" = "lineChartsTemp";
  loadingData: boolean = true;
  zonedata: WarehouseZone;
  cards: CardVariant[];
  showChart: boolean = false;
  zoneUID: string;
  warehouseUID: string;
  heatmapTabs: { name: string; slug: "temperature" | "humidity" }[] = [
    { name: "Temperature Heatmap", slug: "temperature" },
    { name: "Humidity Heatmap", slug: "humidity" },
  ];
  activeSlug: "temperature" | "humidity" = "temperature";

  heatmapDashboardData: {
    totalHum?: number;
    totalTemp?: number;
    data?: HeatmapDashboard[];
  };
  dataPulledAt: string;
  fetchStatus: "fixed" | "live" = "live";

  async ngOnInit() {
    this.title = "Warehouse Zone Details";
    this.zoneUID = this.route.snapshot.params["uniqueId"];
    this.warehouseUID = this.route.snapshot.params["warehouseUID"];
    // this.setCurrentTime();
    // this.setSixHoursPastTime();
    this.fetchRealtime(this.fetchStatus);
    // this.refreshInterval = setInterval(() => {
    //     this.loadRealtimeAvgData();
    //     this.setSixHoursPastTime();
    //     this.setCurrentTime()
    //     this.fetchGraphData();
    //   }, 15000);
    this.store
      .select(selectStoreItems(StoreItemEntity.itemDashboard))
      .subscribe((dashboardData: ItemDashboard[]) => {
        if (dashboardData && !_.isArray(dashboardData)) {
          this.zoneDashboardData = dashboardData as ItemDashboard;
          this.cards = [
            {
              title: "Average Temperature",
              icon: faTemperatureEmpty,
              classes: "text-amber-500 bg-amber-50/60",
              value: this.settingService.formatDegrees(
                this.zoneDashboardData?.avgTemperature?.toString()
              ),
            },
            {
              title: "Average Humidity",
              icon: faDroplet,
              classes: "text-blue-500 bg-blue-50/60",
              value: `${this.zoneDashboardData?.avgHumidity?.toString()}%`,
            },
          ];
        }
      });

    await this.getHeatmapData();
    this.serviceUsage = [
      {
        name: "Temperature",
        data: 78,
        color: "#FD9034",
      },
    ];
    this.loadRealtimeAvgData();
    this.loadDashboardData();
    this.fetchGraphData();

    setTimeout(() => {
      this.showChart = true;
    }, 1000);
    await this.fetchZoneData();
  }
  fetchRealtime(status) {
    switch (status) {
      case "fixed":
        break;
      case "live":
        const now = new Date();
        const then = new Date();
        then.setHours(now.getHours() - 24);
        this.currentTime = this.settingService.formatDateForDateTimeLocal(now);
        this.sixHoursPast =
          this.settingService.formatDateForDateTimeLocal(then);
        this.refreshInterval = setInterval(() => {
          this.loadRealtimeAvgData();
          this.fetchGraphData();
        }, 15000);
    }
  }
  setFetchStatus() {
    this.fetchStatus = "live";
    this.fetchRealtime(this.fetchStatus);
    this.fetchGraphData();
  }

  async getHeatmapData() {
    try {
      const response: any = await this.apollo.query({
        query: GET_ZONE_HEATMAP_DATA,
        variables: {
          filtering: {
            zone: this.route.snapshot.params['uniqueId'],
          },
        },
      });

      const result: BaseResponse<{ dashboardData: string }> = Object.values(
        Object.values(response)[0]
      )[0];

      if (result?.response?.status) {
        this.heatmapDashboardData = {
          data: JSON.parse(result?.data?.dashboardData),
        };

        this.heatmapDashboardData.totalTemp = 0;
        this.heatmapDashboardData.totalHum = 0;
        for (const [
          index,
          datum,
        ] of this.heatmapDashboardData?.data?.entries()) {
          this.heatmapDashboardData.totalTemp += datum?.readings?.temp;
          this.heatmapDashboardData.totalHum += datum?.readings?.hum;
        }
        for (const [
          index,
          datum,
        ] of this.heatmapDashboardData?.data?.entries()) {
          this.heatmapDashboardData.data[index].tempOpacity = (
            (datum?.readings?.temp * 100) /
            this.heatmapDashboardData?.totalTemp
          )
            ?.toString()
            ?.split(".")[0];
          this.heatmapDashboardData.data[index].humOpacity = (
            (datum?.readings?.hum * 100) /
            this.heatmapDashboardData?.totalHum
          )
            ?.toString()
            ?.split(".")[0];
        }
      } else {
        throw Error(result.response.message);
      }
    } catch (e) {
      this.notificationService.errorMessage(e.message);
    }
  }

  async getZone(): Promise<void> {
    this.store.dispatch(
      StoreItemActions.getStoreItems({
        filtering: {
          uniqueId: this.zoneUID,
          pageNumber: 1,
        },
        entity: StoreItemEntity.zone,
        query: GET_ZONE_DATA,
      })
    );
  }

  async fetchZoneData(): Promise<void> {
    await this.getZone();
    this.store
      .select(
        selectFilterStoreItem(StoreItemEntity.zone, { uniqueId: this.zoneUID })
      )
      .subscribe((res) => {
            

        this.zonedata = res;
      });
  }

  loadDashboardData() {
    this.store.dispatch(
      StoreItemActions.getStoreItems({
        query: GET_WAREHOUSE_DASHBOARD_DATA,
        entity: StoreItemEntity.itemDashboard,
        filtering: {
          pageNumber: 1,
          zone: this.zoneUID,
        },
      })
    );
  }
  updateXAxis(readings: any[]): void {
    switch (this.selectedTimeRange) {
      case "hour":
        this.xAxis = readings.map((reading) => {
          const date = new Date(reading.TIMESTAMP);

          const ret = date.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          });

          return ret;
        });
        break;
      case "day":
        this.xAxis = readings.map((reading) => {
          const date = new Date(reading.TIMESTAMP);
          return date.toLocaleTimeString([], {
            weekday: "short",
          });
        });
        break;
      case "week":
        this.xAxis = readings.map((reading) => {
          const date = new Date(reading.TIMESTAMP);
          return `Week ${this.settingService.getWeekNumber(date)}`;
        });
        break;
      case "month":
        this.xAxis = readings.map((reading) => {
          const date = new Date(reading.TIMESTAMP);
          return date.toLocaleTimeString([], {
            month: "short",
          });
        });
        break;
      case "year":
        this.xAxis = readings.map((reading) => {
          const date = new Date(reading.TIMESTAMP);
          return date.getFullYear().toString();
        });
        break;
    }
  }
  closePanel(shouldUpdate = false) {
    this.layoutService.closePanel();
  }
  generateData(count: number, range: { min: number; max: number }): number[] {
    const { min, max } = range;
    const data: number[] = [];

    for (let i = 0; i < count; i++) {
      const randomValue = Math.floor(Math.random() * (max - min + 1)) + min;
      data.push(randomValue);
    }

    return data;
  }

  async loadRealtimeAvgData() {
    // this.loadingData = true

    const query = GET_WAREHOUSE_REALTIME_READINGS;
    const response: any = await this.apollo.queryNoLoader({
      query,
      variables: {
        filtering: {
          pageNumber: 1,
          zone: this.zoneUID,
        },
      },
    });

    const dashboardRealtimeAvgData =
      response?.data?.getWarehouseRealTimeReadings?.data?.dashboardData;
    if (dashboardRealtimeAvgData) {
      try {
        this.dashboardRealtimeSummary = JSON.parse(dashboardRealtimeAvgData);
        const options: Intl.DateTimeFormatOptions = {
          year: "numeric",
          month: "short", // Short month name (e.g., Jan, Feb, etc.)
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // 12-hour clock (e.g., 04:34 PM)
        };
        const date = new Date();
        this.dataPulledAt = new Intl.DateTimeFormat("en-GB", options).format(
          date
        );
      } catch (error) {
        console.error("Error parsing dashboardCardData:", error);
      }
    } else {
      console.error("dashboardCardData is not available");
    }
    this.loadingData = false;
  }

  async fetchGraphData(): Promise<void> {
    this.loadingData = true
    // this.tempLineChartsData = [];
    // this.humLineChartsData = [];
    // this.xAxis = [];

    const query =
      this.activeSlugLineCharts === "lineChartsTemp"
        ? GET_WAREHOUSE_LATEST_READINGS
        : GET_WAREHOUSE_LATEST_READINGS;

    const response: any = await this.apollo.queryNoLoader({
      query,
      variables: {
        filtering: {
          pageNumber: 1,
          zone: this.zoneUID,
          dateFrom: this.sixHoursPast,
          dateTo: this.currentTime,
        },
      },
    });

    const dashboardDataString =
      response?.data?.getWarehouseLatestReadings?.data?.dashboardData;
    if (dashboardDataString) {
      try {
        this.dashboardData = JSON.parse(dashboardDataString);
        this.updateXAxis(this.dashboardData.READINGS);

        this.updateSummaryCards();
        this.updateGraphData();
      } catch (error) {
        console.error("Error parsing dashboardData:", error);
      }
    } else {
      console.error("dashboardData is not available");
    }
    this.loadingData = false;
  }

  async onTimeChange() {
    this.fetchStatus = "fixed";
    await this.fetchGraphData();
  }
  async onTabChange(slug: "lineChartsTemp" | "lineChartsHum") {
    this.activeSlugLineCharts = slug;
    this.showChart = false;
    await this.fetchGraphData();
    this.showChart = true;
  }

  setCurrentTime() {
    const now = new Date();
    this.currentTime = this.settingService.formatDateForDateTimeLocal(now);
  }
  setSixHoursPastTime() {
    const now = new Date();
    now.setHours(now.getHours() - 6);
    this.sixHoursPast = this.settingService.formatDateForDateTimeLocal(now);
  }
  updateSummaryCards() {
    if (this.dashboardData?.SUMMARY) {
      const summary = this.dashboardData.SUMMARY;
      this.cards = [
        {
          title: "Average Temperature",
          icon: faTemperatureEmpty,
          classes: "text-amber-500 bg-amber-50/60",
          value: this.settingService.formatDegrees(
            summary.MAX_TEMPERATURE.toFixed(2)
          ),
        },
        {
          title: "Average Humidity",
          icon: faDroplet,
          classes: "text-blue-500 bg-blue-50/60",
          value: `${summary.MAX_HUMIDITY.toFixed(2)}%`,
        },
      ];
    }
  }

  updateGraphData() {
    const readings = this.dashboardData?.READINGS;

    if (readings && readings.length > 0) {
      const reversedReadings = [...readings].reverse();

      // this.xAxis = reversedReadings.map((reading) => new Date(reading.TIMESTAMP).toLocaleTimeString());

      if (this.activeSlugLineCharts === "lineChartsTemp") {
        this.tempLineChartsData = [
          {
            name: "Temperature",
            data: reversedReadings.map((reading) =>
              parseFloat(reading.TEMPERATURE).toFixed(2)
            ),
            color: "#23AFF1",
          },
        ];
      } else {
        this.humLineChartsData = [
          {
            name: "Humidity",
            data: reversedReadings.map((reading) =>
              parseFloat(reading.HUMIDITY).toFixed(2)
            ),
            color: "#151C51",
          },
        ];
      }
    }
  }
  getItems(event: Device[]) {
    this.items = event?.map((item) => {
      return {
        image: environment.MEDIA_SERVER_URL + item?.posPicture,
        title: item?.description,
      };
    });
  }

  protected readonly faClock = faClock;
}

